import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link, useNavigate } from 'react-router-dom';

function Topbar(props) {

  let navigate = useNavigate()
  let getLogin = sessionStorage.getItem('login')

  function NoLogin() {
    return(
     
      <Navbar bg="light" expand="lg">
        <Container>
          <Navbar.Brand onClick={()=>{navigate("/")}}>{props.blogName}</Navbar.Brand>
          <Nav className="me-auto" onClick={()=>{navigate("/")}}>Home</Nav>      
        <Nav onClick={()=>{navigate('/register')}} style={{marginRight:'10px'}}>회원가입</Nav>
         <Nav onClick={()=>{navigate('/login')}} style={{marginRight:'10px'}}>Login</Nav>
         </Container>
    </Navbar>
         
    )
  }

  function OkLogin() {
    return(
      
        <Navbar bg="light" expand="lg">
        <Container>
          <Navbar.Brand onClick={()=>{navigate("/")}}>{props.blogName}</Navbar.Brand>
          <Nav className="me-auto" onClick={()=>{navigate("/")}}>Home</Nav> 
          <Nav onClick={()=>{navigate("/write")}}>Write</Nav>
         </Container>
    </Navbar>
      
    )
  }
  
  return (
    <div>
    { getLogin ? <OkLogin></OkLogin> : <NoLogin></NoLogin>}
    </div>
  );

  
}


export default Topbar;